/** Sentry DSN for native crash reporting (iOS/Android). Empty = disabled. */
export function getNativeCrashReportingDsn(): string {
  let dsn = '';
  try {
    const cfg = require('./sentry-config.generated') as { SENTRY_DSN?: string };
    dsn = cfg.SENTRY_DSN ?? '';
  } catch {
    // generated file optional until inject runs
  }
  if (!dsn && typeof process !== 'undefined' && process.env.EXPO_PUBLIC_SENTRY_DSN) {
    dsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
  }
  return dsn.trim();
}
